import type { CustomerEnrichmentPort } from '../domain/customer-enrichment'

const cancelCustomerEnrichment = async (port: CustomerEnrichmentPort, customerId: string): Promise<void> => {
	await port.cancel(customerId)
}

export { cancelCustomerEnrichment }
